import React from "react";
import { useAuth } from "../../context/AuthContext";

const LogoutLink = () => {
  const { logout } = useAuth();
  
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
  };

  return (
    <li className="">
      <a href="#logout" onClick={handleLogout} className="nav-link">
        <i className="pe-7s-back-2" />
        <p>Logout</p>
      </a>
    </li>
  );
};

export default LogoutLink;
